import { useState } from 'react';
import { Box, Tabs, Tab, FormControl, InputLabel, Select, MenuItem, Stack } from '@mui/material';
import { useGetAllAvailableIntegrations, useGetAvailableIntegrations } from 'apis/agency/integrations/hook';
import MarketPlace from './components/MarketPlace';
import MyIntegrations from './components/MyIntegrations';
import { useGetIndustries } from '@/apis/industries/hook';
import Search from 'components/Common/Search';

export default function Integrations() {
  const { data: industries } = useGetIndustries();
  const [searchText, setSearchText] = useState<null | string>(null);
  const [industry, setIndustry] = useState<string>(' ');
  const [tabValue, setTabValue] = useState<'my' | 'marketplace'>('my');

  const {
    data: availableIntegrations,
    isLoading,
    refetch: refetchAvailableIntegrations
  } = useGetAvailableIntegrations(
    {
      'filter[name_cont]': searchText,
      'filter[industries_contain]': industry?.trim() || undefined,
      per_page: 99999
    },
    { enabled: tabValue === 'my' } as any
  );

  const {
    data: allAvailableIntegrations,
    isLoading: allIntegrationsLoading,
    refetch: refetchAllAvailableIntegrations
  } = useGetAllAvailableIntegrations(
    {
      'filter[name_cont]': searchText,
      per_page: 9999
    },
    { enabled: tabValue === 'marketplace' } as any
  );

  return (
    <>
      <Box
        display='flex'
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent='space-between'
        alignItems='center'
        gap={1.5}
        mb={2}
      >
        <Tabs
          value={tabValue}
          onChange={(_, val) => setTabValue(val)}
          sx={{
            backgroundColor: '#fff',
            borderRadius: '4px',
            '& .MuiTab-root': {
              padding: '10px 60px'
            }
          }}
        >
          <Tab label='My Integrations' value='my' />
          <Tab label='Marketplace' value='marketplace' />
        </Tabs>

        <Stack direction='row' gap={2}>
          <Search size='small' placeholder='Search Integration' setSearchText={setSearchText} searchText={searchText} />
          {tabValue === 'my' && (
            <FormControl
              size='small'
              sx={{
                minWidth: 180,
                bgcolor: '#fff',
                '& fieldset': {
                  borderColor: '#ececec'
                }
              }}
            >
              <InputLabel>Industry</InputLabel>
              <Select value={industry} label='Industry' onChange={(e) => setIndustry(e.target.value)}>
                <MenuItem value=' '>All</MenuItem>
                {industries?.map((ind, idx) => (
                  <MenuItem key={`${ind}-${idx}`} value={ind.value}>
                    {ind.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Stack>
      </Box>

      {tabValue === 'my' && <MyIntegrations integrations={availableIntegrations} isLoading={isLoading} />}

      {tabValue === 'marketplace' && (
        <MarketPlace
          integrations={allAvailableIntegrations}
          installedIntegrations={availableIntegrations}
          isLoading={allIntegrationsLoading}
          onPurchaseSuccess={async () => {
            setTabValue('my');
            await Promise.all([refetchAvailableIntegrations(), refetchAllAvailableIntegrations()]);
          }}
        />
      )}
    </>
  );
}
